// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ndiv.title[data-v-5a37ab8b] {\r\n\tmargin-top: 10px;\r\n\tmargin-bottom: 5px;\r\n\tcolor: var(--main-gray-5);\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
